import { SIERRA_PERSONA_MAP } from '../constants.ts';

import {
    type SupportChatTouchpoint,
    type PreChatFields,
    type SupportChatEndUserType,
} from '../../types.ts';

type SierraVariables = PreChatFields & {
    touchpoint: SupportChatTouchpoint;
    persona: SupportChatEndUserType;
};

function getSierraVariables({
    touchpoint,
    preChatFields,
}: {
    touchpoint: SupportChatTouchpoint;
    preChatFields: PreChatFields;
}): SierraVariables {
    return {
        ...preChatFields,
        touchpoint,
        persona: SIERRA_PERSONA_MAP[touchpoint],
    };
}

export { getSierraVariables };
